import React from "react"
import { Typography, Divider } from "antd"

const { Title, Paragraph } = Typography

const PurchasePolicyPage = () => {
  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(to bottom, #f8f9fa, #e9ecef)",
        padding: "40px 20px",
      }}
    >
      <div
        style={{
          maxWidth: "800px",
          margin: "0 auto",
          background: "rgba(255,255,255,0.95)",
          borderRadius: "20px",
          padding: "32px",
          boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
        }}
      >
        <Title level={2} style={{ textAlign: "center", fontWeight: 700 }}>
          📄 Chính sách mua hàng
        </Title>
        <Divider />

        <Paragraph style={{ fontSize: "15px", lineHeight: "1.8" }}>
          Dưới đây là các quy định và hướng dẫn liên quan đến việc mua bảo hiểm
          tại hệ thống Bảo hiểm trách nhiệm dân sự:
        </Paragraph>

        <ul style={{ paddingLeft: "20px", fontSize: "15px", color: "#333" }}>
          <li>
            ✅ Khách hàng có thể mua bảo hiểm xe ô tô và xe máy trực tuyến 100%.
          </li>
          <li>
            ✅ Sau khi thanh toán thành công, chứng nhận bảo hiểm được gửi về email.
          </li>
          <li>
            ✅ Hỗ trợ hoàn tiền trong vòng 24h nếu xảy ra lỗi hoặc yêu cầu hợp lệ.
          </li>
          <li>
            ✅ Mọi thông tin cá nhân được mã hóa và lưu trữ an toàn.
          </li>
          <li>
            ✅ Mọi yêu cầu hỗ trợ vui lòng liên hệ hotline hoặc fanpage chính thức.
          </li>
        </ul>

        <Divider />

        <Paragraph type="secondary" style={{ textAlign: "center", marginTop: "20px" }}>
          Cảm ơn bạn đã tin tưởng và sử dụng dịch vụ của Bảo hiểm trách nhiệm dân sự.
        </Paragraph>
      </div>
    </div>
  )
}

export default PurchasePolicyPage
